export default __webpack_public_path__ + "static/media/screenshot17.67849ca6.jpg";